import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';
import { SelectItem } from 'vet-bones/utils/select';

import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import * as copy from 'src/templates/copy';

export const projectAttributeDomainsByIriSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectAttributesByIriSelector(projectId),
      projectLabelsByIriSelector(projectId),
      (attributesByIri, labelsByIri) =>
        Object.values(attributesByIri).reduce<Record<string, SelectItem[]>>(
          (acc, { value, domains }) => {
            acc[value] = Object.keys(domains)
              .map((domain) => ({
                text: getLabelForIri(
                  labelsByIri,
                  domain,
                  copy.components.projectDiagram.modelConceptClass.new
                ),
                value: domain,
              }))
              .sort(alphaSort((item) => item.text));
            return acc;
          },
          {}
        )
    )
);
